import {Stack, TextField, TextFieldProps, Typography} from '@mui/material';
import {forwardRef} from 'react';
import {STYLES} from './styles';

interface Props extends Omit<TextFieldProps, 'variant' | 'inputRef'> {
  maxWidth?: string;
}

export const InputField = forwardRef<HTMLInputElement, Props>(({label, maxWidth, sx, ...props}, ref) => {
  return (
    <Stack gap="10px">
      {label && <Typography sx={STYLES.label}>{label}</Typography>}
      <TextField inputRef={ref} sx={{...STYLES.field, ...sx, maxWidth}} variant="outlined" {...props} />
    </Stack>
  );
});
